import { Drawer,Spin } from "antd";
import React from "react";
import { setViewAttachobgDocsdrawerVisible } from "../MyObligation.Slice";
import { useDispatch } from "react-redux";

const ViewAttachobgDocsdrawer = (props) => {
  const {
    // intl: { formatMessage },
    MyObligation: {
     
      isDrawerdataLoading,
      
      isAttachedDocsVisible,
      AttachedDocsrecord
    },
   
  } = props;
  const dispatch = useDispatch();





  return (
    <Drawer
      title={"Attached Documents"}
      width={window.innerWidth <= 720 ? "100%" : "40%"}
      open={isAttachedDocsVisible}
      onClose={() => {
        dispatch(setViewAttachobgDocsdrawerVisible({ visible: false }));
      }}
    >
    <Spin spinning={isDrawerdataLoading}>
      <div style={{padding:"15px"}}>
      <iframe
              title="PDF Viewer"
              src={AttachedDocsrecord}
              width="100%"
              height="650px" // Adjust the height as needed
              frameBorder="0"
            ></iframe>
      </div>
      </Spin>
    </Drawer>
  );
};

export default ViewAttachobgDocsdrawer;
